export default function isFirstBlock(editor) {
  if (!editor.value.selection.isSet) return false;
  var _editor$value = editor.value,
      document = _editor$value.document,
      startBlock = _editor$value.startBlock,
      endBlock = _editor$value.endBlock;
  var firstBlock = document.getBlocks().first();
  return firstBlock && (startBlock.key === firstBlock.key || endBlock.key === firstBlock.key);
}